export default {
  productCodesResults: [],
};
